import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Money from 'core/api/Money';
import { Radio } from 'core/ui/atoms';

const BaseMeal = ({
  item,
  baseMealItem,
  isSelected,
  onSelectedMealChange,
}) => {
  const { cost } = item;

  const RenderContainer = ({ children }) => {
    if (isSelected) {
      return <SelectedProductContainer>{children}</SelectedProductContainer>;
    } else {
      return <ProductContainer>{children}</ProductContainer>;
    }
  };

  const mealSize = item?.variants.find((variant) => variant.id === item.variantId)?.displayName;

  const getAmount = () => {
    const baseMealAmount = baseMealItem?.cost?.amount;
    const costAmount = cost?.amount;

    if (costAmount > baseMealAmount) {
      const differenceAmount = {
        __typename: 'Money',
        amount: costAmount - baseMealAmount,
      };
      return `(+${Money(differenceAmount).toFormat('$0,0')})`;
    } else if (baseMealAmount > costAmount) {
      const creditAmount = {
        __typename: 'Money',
        amount: baseMealAmount - costAmount,
      };
      return `(Credit ${Money(creditAmount).toFormat('$0,0')})`;
    }
  };

  return (
    <RenderContainer onClick={onSelectedMealChange}>
      <RadioContainer>
        <Radio
          name={item.id}
          value="0"
          checked={isSelected}
          onChange={onSelectedMealChange}
        />
      </RadioContainer>
      <TagContainer>
        {mealSize}{' '}{getAmount()}
      </TagContainer>
    </RenderContainer>
  );
};

BaseMeal.propTypes = {
  item: PropTypes.object.isRequired,
  baseMealItem: PropTypes.object,
  onSelectedMealChange: PropTypes.func,
  isSelected: PropTypes.bool,
};

const TagContainer = styled.div`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
`;

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: ${(p) => p.theme.colors.white};
  border: 2px solid ${(p) => p.theme.colors.grays.light};
  width: auto;
  flex: 1;
  max-width: fit-content;
  padding-left: 5px;
  padding-right: 10px;
`;

const SelectedProductContainer = styled(ProductContainer)`
  background: linear-gradient(0deg, rgba(197, 209, 192, 0.60) 0%, rgba(197, 209, 192, 0.60) 100%), #FFF;
`;

export default BaseMeal;
